/**
 * Created by Administrador on 10/14/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('roles', {
                parent: 'app',
                url: '/roles?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/role/roles.html',
                        controller: 'roleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['role']);
                    }],
                    roles: ['roleService','$stateParams', function(roleService,$stateParams){
                        return roleService.getPageRoles($stateParams.page, $stateParams.size);
                    }]
                }
            })
            .state('roleNew', {
                parent: 'app',
                url: '/role/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/role/newRole.html',
                        controller: 'newRoleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['role']);
                    }],
                    clients: ['clientService', function(clientService){
                        return clientService.getAllApplicationUiTrue();
                    }]
                }
            })
            .state('roleEdit', {
                parent: 'app',
                url: '/role/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/role/editRole.html',
                        controller: 'editRoleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['role']);
                    }],
                    role: ['$stateParams', 'roleService', function($stateParams, roleService){
                        return roleService.getRole($stateParams.id);
                    }],
                    clients: ['clientService', function(clientService){
                        return clientService.getAllApplicationUiTrue();
                    }]
                }
            })
            .state('roleDelete', {
                parent: 'roles',
                url: '/role/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/role/deleteRole.html',
                        controller: 'deleteRoleController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'roleId': [function() {
                                return $stateParams.id
                            }],
                            'role': ['roleService', function(roleService) {
                                return roleService.getRole($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('roles', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
